import { makeStyles, Spinner } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { useApiCall } from "../../../hooks/useApiCall";
import { useAppSelector } from "../../../store/StoreHooks";
import { getAirportCode } from "../../../store/airport/AirportSelector";
import {
  AIRPORT_CODE_PARAMETER,
  EMPTY_STATE_MESSAGE,
} from "../../../utils/common/Constants";
import { NoDataCard } from "../../common/no-data-card/NoDataCard";
import FlightDemandCapacityChart from "./FlightDemandCapacityChart";
import {
  FlightDemandCapacityHeaderMain,
  FlightDemandCapacitySubHeader,
} from "./FlightDemandCapacityHeader";

export default function FlightDemandCapacity() {
  const airport = useAppSelector((state: any) => getAirportCode(state));
  const [timeRefs, setTimeRefs] = useState<{ [key: string]: string }>({});
  const [refreshMap, setRefreshMap] = useState<{ [key: string]: boolean }>({});
  const [selectedButtons, setSelectedButtons] = useState<any>([]);

  const classes = useStyles();

  const getRunwayUrl = `${process.env.REACT_APP_API_RUNWAYS?.replace(
    AIRPORT_CODE_PARAMETER,
    airport
  )}`;
  const {
    data: runwayResponseData,
    error: errorRunway,
    isLoading: isRunwayLoading,
  } = useApiCall<any>({
    url: getRunwayUrl,
    dependencies: [airport],
  });

  useEffect(() => {
    if (
      runwayResponseData &&
      Array.isArray(runwayResponseData) &&
      runwayResponseData.length > 0
    ) {
      setSelectedButtons([runwayResponseData[0]]);
    }
  }, [runwayResponseData]);

  const handleButtonClick = (buttonName: string) => {
    if (selectedButtons.includes(buttonName)) {
      const updatedButtons = selectedButtons.filter(
        (value: string) => value !== buttonName
      );
      setSelectedButtons(updatedButtons);
    } else {
      if (Array.isArray(runwayResponseData)) {
        const allButtons = runwayResponseData;
        const updatedButtons = [...selectedButtons, buttonName];
        updatedButtons.sort(
          (a, b) => allButtons.indexOf(a) - allButtons.indexOf(b)
        );
        setSelectedButtons(updatedButtons);
      } else {
        setSelectedButtons([...selectedButtons, buttonName]);
      }
    }
  };

  return (
    <div
      data-testid="flight-demand-capacity-component"
      style={{ minHeight: "700px" }}
    >
      <>
        <FlightDemandCapacityHeaderMain
          selectedButton={selectedButtons}
          handleButtonClick={handleButtonClick}
          resourceData={runwayResponseData}
          airport={airport}
        />
        {errorRunway && <NoDataCard message={EMPTY_STATE_MESSAGE.Data} />}
        {isRunwayLoading ? (
          <Spinner
            labelPosition="below"
            label="Loading..."
            className={classes.cardLoader}
          />
        ) : null}
        {!errorRunway && !isRunwayLoading ? (
          <>
            {selectedButtons.map((runway: string) => (
              <div key={runway} style={{ minHeight: "700px" }}>
                <FlightDemandCapacitySubHeader
                  selectedButton={[runway]}
                  airport={airport}
                  timeRef={timeRefs[runway] || "Block"}
                  setTimeRef={(value: any) =>
                    setTimeRefs((prev) => ({ ...prev, [runway]: value }))
                  }
                  refresh={!!refreshMap[runway]}
                  setRefresh={(value: any) =>
                    setRefreshMap((prev) => ({ ...prev, [runway]: value }))
                  }
                />

                <FlightDemandCapacityChart
                  runway={runway}
                  selectedButton={[runway]}
                  airport={airport}
                  timeRef={timeRefs[runway] || "Block"}
                  refresh={!!refreshMap[runway]}
                />
              </div>
            ))}
          </>
        ) : null}
      </>
    </div>
  );
}
const useStyles = makeStyles({
  cardLoader: {
    height: "100%",
  },
});
